import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { getToken } from '../../../../helpers/Jwt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faClose, faDisplay, faEyeSlash, faPencil, faSign, faSignHanging, faSignIn, faSignLanguage, faSignature, faSigning, faTrash } from '@fortawesome/free-solid-svg-icons';
import ModalSign from '../../component/ModalSign/ModalSign';
import BadgeStatus from '../../component/BadgeStatus/BadgeStatus';
import { confirmDelete } from '../../../../helpers/PromptUtils';
import RichTextEditor from './RichTextEditor';

const DetailNews = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [text, setText] = useState("");
    const [detailData, setDetailData] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_NEWS = "api/kejati/dashboard/news";

    const fetchData = async (url, headers) => {
        setLoading(true);
        try {
            const response = await axios.get(url, { headers });
            return response.data;
        } catch (err) {
            setError("Gagal memuat data. Silakan coba lagi.");
            console.error(err);
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_NEWS}/detail?id=${id}`, {
                Authorization: `Bearer ${getToken()}`,
                "Content-Type": "application/json"
            }).then((detail) => {
                setDetailData(detail);
                setText(detailData?.article)
            });
        }
    }, [id]);

    const handleHide = async () => {
        try {
            const response = await axios({
                method: "POST",
                url: `${BASE_URL}${PATH_NEWS}/hide`,
                data: { id },
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "application/json"
                }
            });

            const { message } = response.data;

            alert(message);
            window.location.reload();
        } catch (error) {
            alert(error)
        }
    }

    const handleShow = async () => {
        try {
            const response = await axios({
                method: "POST",
                url: `${BASE_URL}${PATH_NEWS}/show`,
                data: { id },
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "application/json"
                }
            });

            const { message } = response.data;

            alert(message);
            window.location.reload();

        } catch (error) {
            alert(error)
        }
    }

    const handleDelete = async () => {
        const confirmed = confirmDelete('Are you sure you want to delete this data?');
        if (confirmed) {
            try {
                const response = await axios({
                    method: "POST",
                    url: `${BASE_URL}${PATH_NEWS}/delete`,
                    data: { id },
                    headers: {
                        Authorization: `Bearer ${getToken()}`,
                        "Content-Type": "application/json"
                    }
                });

                const { message } = response.data;

                alert(message);
                navigate(`/activity-kejati/manage-news`);

            } catch (error) {
                alert(error)
            }
        }
    }

    const handleEdit = () => {
        navigate(`/activity/edit-news/${id}`);
    }

    const statusColor = (status) => {
        switch (status) {
            case 'show':
            case '':
                return 'info';
            case 'hide':
                return 'warning';
            case 'default':
                break;
        }
        return 'default';
    }

    return (
        <div className="font-sans p-6 min-h-screen">
            <div className='flex justify-between'>
                <h1 className="text-2xl font-bold text-gray-800 mb-6">Data Detail</h1>
            </div>
            {loading ? (
                <p>Memuat Data Berita...</p>
            ) : (
                <div className='p-3 rounded-lg shadow-md bg-white'>
                    <div className='flex justify-between'>
                        <div className="px-3">
                            <img src={`${BASE_URL}/upload/${detailData?.image}`} alt={detailData?.headline} className="w-full h-48 object-cover" />
                        </div>
                        <div>
                            <BadgeStatus text={detailData?.status == 'show' ? "Ditampilkan" : "Disembunyikan"} status={() => statusColor(detailData?.status)} />
                        </div>
                    </div>
                    <div className='px-3 my-4'>
                        <button onClick={handleHide} type='button' className='text-white text-xs rounded focus:ring bg-red-500 hover:bg-red-700 p-2 mx-1'>
                            <FontAwesomeIcon icon={faEyeSlash} color="white" /> Sembunyikan
                        </button>
                        <button onClick={handleShow} type='button' className='text-white text-xs rounded focus:ring bg-blue-500 hover:bg-blue-700 p-2 mx-1'>
                            <FontAwesomeIcon icon={faDisplay} color="white" /> Tampilkan
                        </button>
                        <button onClick={handleEdit} type='button' className='text-white text-xs rounded focus:ring bg-yellow-500 hover:bg-yellow-700 p-2 mx-1'>
                            <FontAwesomeIcon icon={faPencil} color="white" /> Ubah
                        </button>
                        <button onClick={handleDelete} type='button' className='text-white text-xs rounded focus:ring bg-red-500 hover:bg-red-700 p-2 mx-1'>
                            <FontAwesomeIcon icon={faTrash} color="white" /> Hapus
                        </button>
                    </div>
                    <hr className='my-5' />
                    <div className="grid grid-cols-1 gap-6">
                        <h2 className="text-xl font-semibold text-gray-800 mb-2">
                            {detailData?.headline}
                        </h2>
                        <div className="text-sm text-gray-500 mb-4">
                            <span>By: {detailData?.author}</span> | <span>Category: {detailData?.category}</span>
                        </div>
                        <p className="text-gray-600 mb-4">
                            {detailData?.description}
                        </p>

                        <p className="text-lg text-gray-700 leading-relaxed">
                            <div dangerouslySetInnerHTML={{ __html: detailData?.article }} />
                        </p>
                    </div>
                </div>
            )}
        </div>
    )
}

export default DetailNews;